export default function Container(theme) {
  return {
    MuiContainer: {
      defaultProps: {
        maxWidth: false,       // elimina el límite de ancho
        disableGutters: true,  // quita el padding horizontal
      },
      styleOverrides: {
        root: {
          width: '100%',       // siempre al 100% ancho
        },
      },
    },
  };
}
